<template>
  <div class="SupplierList">
    <div class="row">
      <div
        v-for="item in suppliers"
        :key="item.id"
        class="col-12 col-sm-6 col-md-6 col-lg-4"
      >
        <SupplierCard :supplier="item" />
      </div>
    </div>
  </div>
</template>

<script>
import SupplierCard from '@/components/supplier/Card.vue';

export default {
  name: 'SupplierList',
  components: {
    SupplierCard,
  },
  props: {
    suppliers: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .SupplierCard {
  margin-bottom: 15px;
}
</style>
